import { Participant, ParticipantKind } from 'livekit-client';
import { useSIPTelephony } from 'useCase';

export const useSIPParticipant = () => {
    const { isSIPOn } = useSIPTelephony();

    const checkIsSIPParticipant = (participant: Participant) => {
        if (!isSIPOn()) return false;

        return participant.kind === ParticipantKind.SIP;
    };

    const getSIPParticipantName = (participant: Participant) => {
        return participant.identity;
    };

    return {
        checkIsSIPParticipant,
        getSIPParticipantName,
    };
};
